module.exports = {
  message: {
    title: "Sport Brands",
  },
  placeholder: {
    enter: "Please type in your favorite brand",
  },
  brands: {
    nike: "Nike",
    adi: "Adidas",
    nb: "New Banlance",
    ln: "LI Ning",
  },
  menue: {
    detail: "SocialDetails",
    find: "Find",
    porj: "Increase PresetProject",
    custom: "CustomManagement",
    report: "Research",
    setting: "Setting",
  },
  topHead: {
    select_option_category: "Category",
    select_option_category_holder:
      "You can enter Title keywords or product links to search",
    select_option_brand: "Brand",
    select_option_brand_holder: "Please select",
    select_option_topic: "Topic",
    select_option_topic_holder: "Please enter the content",
    select_option_postKeyWords: "PostKeywords",
    select_option_postKeyWords_holder: "Please enter the content",
    rules_message_search: "Enter at least one brand or post content",
    my_attention: "MyAttention",
    login_label: "SignIn",
    login_out: "SignOut",
    Chinese: "中文",
    English: "English",
  },
  mainHead: {
    eidtTooltip: "Edit search criteria",
    platList_weibo: "Micro Blog",
    platList_douyin: "Tik Tok",
    platList_xhs: "Red Booklet",
    platList_bzhan: "bilibili",
    platList_kuaishou: "quick worker",
    platList_weixin: "WeChat",
    platList_jrtt: "toutiao",
    platList_zhihu: "zhihu",
    platList_dewu: "Poizon",
    platList_hupu: "hoopCHINA",
    dateLabel: "Date",
    date_to: "To",
    date_holder: "Select month",
    saveProj: "Save scheme",
    tabs_baseInfo: "BaseInfo",
    tabs_crowdPortrait: "Crowd portrait",
    tabs_talents: "Talent list",
    tabs_brand: "Brand list",
    tabs_topic: "Topic analysis",
    tabs_custom: "Custom analysis",
    tabs_ai: "DeepSeek interpretation",
    rules_message_search:
      "Enter at least one brand or category or post content",
    rules_message_search2:
      "At least one of the brand or category or post content is not empty",
    rules_message_range: "Time range cannot be empty",
    message_saveProj_success: "Scheme saved successfully",
    message_saveProj_failed: "Failed to save scheme",
    headProductText: "Why is it worth buying：",
  },
  search: {
    title: "Add search criteria",
    form_postWord: "PostKeywords",
    form_postWord_tip:
      "Support and, or, not logic, and word segmentation are separated by spaces; For example: lipstick and (Lip Glaze or lip gloss) not matte",
    form_brand: "Brand",
    form_brand_holder: "Enter brand keywords",
    form_brand_tip:
      "For example, searching for the brand 'apple / Apple' will filter out the posts containing 'Apple' or 'Apple' or 'apple / Apple', and the posts representing 'apple / Apple' can be determined through semantic analysis.",
    form_topic: "topic",
    form_topic_holder: "Please enter topic keywords",
    form_category: "Category",
    form_cat_tip: "Please select the category you want to view.",
    form_plat: "Platform",
    form_platOption_douyin: "Tik Tok",
    form_platOption_weibo: "Micro Blog",
    form_platOption_xhs: "Red Booklet",
    form_dateRange: "TimeRange",
    form_dateRange_holder: "Select month",
    form_dateRange_to: "To",
    searchBtnLab: "Search",
    operation: "Operation",
    form_user_name: "User Name",
  },
  baseInfo: {
    trend: "trend",
    posts: "Post",
    posts_toolTip: "Number of All Posts",
    interaction: "Interaction",
    interaction_toolTip: "Comments + Likes + Forwards",
    nsr: "NSR",
    nsr_toolTip:
      "(Positive volume - Negative volume) / (Positive volume + Negative volume) *100%",
    soe_toolTip: "soe",
    sov_toolTip: "sov",
    platTitle: "Platform distribution",
    cloudWordTitle: "WordCloud",
    TalentTitle: "Top 10 list of talents",
    PostListLabel: "Volume ranking",
    IteractionListLabel: "Interaction ranking",
    BrandTitle: "Brand top 10 list",
    postContent: "Original post",
    postType_all: "Overall",
    postType_Forward: "Positive",
    postType_back: "Negative",
    postType_neutral: "Neutral",
    selectedCondition: "Selected Conditions",
    postKeyWordLabel: "Post Keywords:",
    mustKwLabel: "Required Words：",
    shouldKwLabel: "Optional words：",
    notKwLabel: "Exclusion words：",
    kolWord: "User Name：",
    kolMustKwLabel: "User Name Required Words：",
    kolShouldKwLabel: "User Name Optional words：",
    kolNotKwLabel: "User Name Exclusion words：",
    cloudWordLabel: "CloudWord:",
    kolLabel: "KOL:",
    catLabel: "Category：",
    brandLabel: "Brand:",
    brand: "Brand",
    topic: "Topic",
    topicLabel: "Topic：",
    originPostLink: "Posts Link",
    negativePostPercent: "Proportion of negative posts",
    reposts: "Forwarding",
    comments: "Comments",
    zans: "Likes",
    participle: "Participle",
    frequency: "Frequency",
    photo: "Photo",
    Talent: "Talent",
    plant: "platform",
    fansNum: "FansNum",
    downLoad: "DownLoad",
    downLoading: "DownLoading...",
    ranking: "Ranking",
    cloud_nameLabel: "word",
    cloud_valueLabel: "count",
    gender: "gender",
    age: "age",
    region: "region",
    cityLevel: "cityLevel",
    g_aspect: "emotion",
    interest: "interest",
    interestStatistics: "interest word cloud and word frequency count",
    distribution: "distribution",
    concerned: "concerned",
    category: "category",
    user: "Users",
    tgi: "TGI",
    man: "man",
    woman: "woman",
    max: "max",
    min: "min",
    qoq: "qoq",
    yoy: "yoy",
    sentiment: "Sentiment analysis",
    fansProportion: "Proportion of fans",
    rate: "rate",
    KOL: "KOL",
    KOC: "KOC",
    consumer: "consumer",
  },
  TalentList: {
    allPosts: "All Posts",
    forwardPosts: "Positive Posts",
    backPosts: "Negative Posts",
    neutralPosts: "Neutral Posts",
  },
  brandList: {
    add: "add",
    brand: "brand",
    name: "name",
    rule: "rule",
    confirm: "confirm",
  },
  proj: {
    title: "Preset Project",
    userDefinedName: "Custom name",
    postsKeyWords: "Post keyword",
    brand: "Brand",
    cat: "Category",
    Talent: "Talent",
    plant: "platform",
    date: "Date",
    to: " To ",
  },
  setting: {
    phone_set: "Mobile Number Setting",
    mail_set: "Email Setting",
    primary_number: "Your Primary Mobile Number",
    mail_number: "Your email address",
    second_number: "Your Secondary Mobile  Number",
    delete: "Delete",
    phone_placeholder: "Please enter content",
    sms: "SMS login verification",
    add: "Add mobile number",
    add_mail: "Add email",
    success: "Mobile number added successfully",
    confirm: "Confirm",
    dialog_phone: "Primary Mobile Number",
    dialog_input_placeholder: "Enter verification code",
    verification: "Verification",
    cancel: "Cancel",
    yesterday: "yesterday",
    7: "Nearly 7 days",
    30: "Nearly 30 days",
    90: "Nearly 90 days",
    enter_num: "Enter your phone number",
    enter_mail: "Enter your email number",
    enter_correct_num: "Enter the correct phone number",
    enter_correct_mail: "Please enter a valid email",
    first_num: "The first phone number must enable SMS login verification.",
    note: "note",
    optional: "note(optional)",
    desc: "Overseas mobile phone number filling format:+area code mobile phone number",
    example: "For example: +852 61234567",
  },
  changePasswordPanel: {
    change_password_title:
      "Change The Password (Only the primary mobile number is available)",
    change_password: "Change password",
    use_latest_cat:
      "When the platform category structure changes, use the latest category structure to track historical data.",
    message_success: "Successfully modified.",
  },
  userInfo: {
    enter_phone_title: "Phone number verification",
    enter_email_title: "Email verification",
    enter_phone_placeholder: "Please enter your phone number",
    enter_email_placeholder: "Please enter your email",
    enter_sms: "Please enter the verify code",
    get_sms: "Get verify code",
    verify: "Verify",
    cancel: "Cancel",
  },
  footer: {
    content_one:
      "All data of Magic Mirror Insight come from public pages. Magic Mirror Insight has no direct connection with Taobao, Tmall, JINGdong, Amazon and other e-commerce platforms, and is an independent third-party e-commerce data agency  ",
    content_two: "@2025 Beijing Taomi Technology Limited Co., LTD. ",
    content_icp: "Beijing ICP 15061734-4 ",
    content_goan: "Beijing network security 11010502037832 ",
    content_add:
      "Data is collected and summarized by the public page, the data caliber is different from that of the platform and other organizations, and it is for reference only. If there is any difference, please refer to the official data released by the platform.",
  },
  downloadSelection: {
    table: "Download as a table.",
    image: "Download as a picture.",
    bubble: "Download as a bubble Chart",
    lineBar: "Download as a line-bar chart",
    bar: "Download as a bar chart",
    pie: "Download as a pie chart",
  },
};
